<div id="promo-wrapper">
    <section id="promo" class="mt-4 mb-4">
        <div class="container dark">
            <div class="eyebrow" i18n>ImmoConnect von AlbCode</div>
            <header>
                <h2 i18n>Immobilienverwaltung digital organisieren – vom Objekt bis zum Schaden</h2>
            </header>

            <p class="lead" i18n>
                <strong>ImmoConnect</strong> ist eine webbasierte Software für Immobilienverwaltungen, Hausverwaltungen und Objektbetreuer. Die Lösung verbindet
                <strong>Objekte und Wohneinheiten</strong> mit Schäden, Aufgaben, E-Mails, Dokumenten, Kontakten und Terminen in einer gemeinsamen digitalen Arbeitsumgebung.
            </p>

            <p i18n>
                Statt Informationen in Postfächern, Dateiordnern und Excel-Listen zu suchen, finden Mitarbeitende die vollständige Kommunikation und Bearbeitungshistorie direkt am
                passenden Objekt oder Vorgang. Das schafft eine nachvollziehbare <strong>digitale Objektakte</strong> und erleichtert die Zusammenarbeit im Team.
            </p>

            <ul>
                <li i18n><strong>Objekt- und Wohneinheitenverwaltung:</strong> Gebäude, Einheiten, Kontakte und zugehörige Informationen strukturiert verwalten.</li>
                <li i18n><strong>Schadensmanagement:</strong> Schäden und Instandhaltungsvorgänge mit Status, Aufgaben, Dokumenten und Kommunikation nachverfolgen.</li>
                <li i18n><strong>Integrierte E-Mail:</strong> Nachrichten und Anhänge direkt Objekten, Wohneinheiten, Schäden, Projekten oder Dienstleistungen zuordnen.</li>
                <li i18n><strong>Kalender & Android-App:</strong> Termine im Team planen und den Kalender mobil auf Android nutzen.</li>
                <li i18n><strong>Dokumente & Office-Bearbeitung:</strong> Word- und Excel-Dateien aus dem Vorgang heraus öffnen, bearbeiten und zentral speichern.</li>
                <li i18n><strong>Projekte, Dienstleistungen & Newsletter:</strong> Wiederkehrende Abläufe und Kommunikation ohne zusätzliche Insellösungen organisieren.</li>
            </ul>
        </div>
    </section>
</div>

<div class="wrapper pb-3">
    <section class="container">
        <div class="row features justify-content-center">
            <main class="container">
                <section class="section grid grid-3" aria-label="Kernfunktionen der Immobilienverwaltungssoftware" i18n-aria-label>
                    <article class="card mb-0">
                        <span class="feature-icon" aria-hidden="true"><i class="fa-solid fa-building"></i></span>
                        <span class="badge" i18n>Digitale Objektakte</span>
                        <h3 i18n>Objekte und Wohneinheiten zentral</h3>
                        <p i18n>Alle relevanten Kontakte, Aufgaben, E-Mails, Dokumente und Notizen bleiben beim richtigen Gebäude, der richtigen Wohneinheit oder dem jeweiligen Vorgang.</p>
                    </article>
                    <article class="card mb-0">
                        <span class="feature-icon" aria-hidden="true"><i class="fa-solid fa-screwdriver-wrench"></i></span>
                        <span class="badge" i18n>Schadensmanagement</span>
                        <h3 i18n>Vom Eingang bis zur Erledigung</h3>
                        <p i18n>Schadensfälle strukturiert erfassen, Verantwortlichkeiten zuweisen und die vollständige Bearbeitung mit Kommunikation, Anhängen und Aufgaben dokumentieren.</p>
                    </article>
                    <article class="card mb-0">
                        <span class="feature-icon" aria-hidden="true"><i class="fa-solid fa-envelope"></i></span>
                        <span class="badge" i18n>E-Mail-Integration</span>
                        <h3 i18n>Kommunikation gehört zum Vorgang</h3>
                        <p i18n>Eingehende und ausgehende Nachrichten werden der passenden Einheit, dem Schaden, Projekt oder Dienstleistungsfall zugeordnet. Aus E-Mails entstehen direkt Aufgaben.</p>
                    </article>
                </section>

                <section class="section grid grid-2" id="kalender-app">
                    <article class="card mb-0 highlight-card">
                        <span class="badge" i18n>Kalender für Hausverwaltungen</span>
                        <h3 i18n>Besichtigungen, Handwerker- und Teamtermine planen</h3>
                        <p i18n>Der integrierte Kalender unterstützt Tages-, Wochen-, Monats- und Agendaansichten. Termine können mit internen Benutzern, Kontakten und externen Teilnehmern
                            geplant sowie mit Einladungen und Erinnerungen versehen werden.</p>
                        <ul class="list">
                            <li i18n>Teilnehmer, Zuständigkeit und Sichtbarkeit verwalten</li>
                            <li i18n>Einladungen und Terminabsagen per iCalendar versenden</li>
                            <li i18n>Erinnerungen für wichtige Fristen und Vor-Ort-Termine</li>
                        </ul>
                    </article>
                    <article class="card mb-0 highlight-card">
                        <span class="badge" i18n>Native Android-App</span>
                        <h3 i18n>Der ImmoConnect-Kalender unterwegs</h3>
                        <p i18n>Die Android-App verbindet sich sicher mit ImmoConnect und übernimmt das individuelle Erscheinungsbild. Termine lassen sich mobil ansehen, erstellen, bearbeiten,
                            verschieben, absagen oder löschen.</p>
                        <ul class="list">
                            <li i18n>Tag-, Woche-, Monat- und Agendaansicht</li>
                            <li i18n>Kontakte und Teilnehmer direkt aus ImmoConnect</li>
                            <li i18n>Lokale Terminerinnerungen auf dem Android-Gerät</li>
                        </ul>
                    </article>
                </section>

                <section class="section" id="arbeitsablaeufe">
                    <div class="section-heading">
                        <span class="eyebrow" i18n>Weniger Medienbrüche</span>
                        <h2 i18n>Die tägliche Immobilienverwaltung in einem System</h2>
                        <p i18n>ImmoConnect konzentriert sich auf die operativen Abläufe rund um Objekte, Kommunikation, Vorgänge und Zusammenarbeit.</p>
                    </div>
                    <div class="grid grid-3 mt-3">
                        <article class="card mb-0">
                            <h3 i18n>Aufgaben & Verantwortlichkeiten</h3>
                            <p i18n>Aufgaben aus E-Mails oder Dokumenten erstellen, Mitarbeitenden zuweisen, Fristen setzen und Bearbeitungsstände nachvollziehen.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Dokumente direkt bearbeiten</h3>
                            <p i18n>Word- und Excel-Dateien ohne Download- und Upload-Schleifen im System öffnen, bearbeiten und wieder am richtigen Vorgang speichern.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Kontakte & Ansprechpartner</h3>
                            <p i18n>Mieter, Eigentümer, Dienstleister und weitere Ansprechpartner mit ihren Objekten, Einheiten und laufenden Vorgängen verbinden.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Projekte & Dienstleistungen</h3>
                            <p i18n>Größere Maßnahmen und wiederkehrende Servicefälle mit Aufgaben, Dokumenten, E-Mails, Kontakten und Notizen bündeln.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Newsletter & Empfängerlisten</h3>
                            <p i18n>Informationen gezielt an gepflegte Empfängerlisten versenden und die Kommunikation direkt aus der zentralen Anwendung organisieren.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Individuell anpassbar</h3>
                            <p i18n>Rollen, Branding, Kategorien, Schnittstellen und branchenspezifische Abläufe lassen sich passend zu Ihrer Organisation erweitern.</p>
                        </article>
                    </div>
                </section>

                <section class="section grid grid-2" id="positionierung">
                    <article class="card mb-0">
                        <span class="badge" i18n>Für wen?</span>
                        <h3 i18n>Für Verwaltungen mit vielen parallelen Vorgängen</h3>
                        <p i18n>ImmoConnect eignet sich für Immobilien- und Hausverwaltungen, Bestandshalter sowie Objektbetreuer, die Informationen nicht länger über persönliche Postfächer,
                            Netzlaufwerke und Tabellen verteilen möchten.</p>
                    </article>
                    <article class="card mb-0">
                        <span class="badge" i18n>Klare Ausrichtung</span>
                        <h3 i18n>Operative Prozesse statt Buchhaltungsballast</h3>
                        <p i18n>Die Lösung fokussiert die digitale Objektakte, Vorgänge, Schäden, Aufgaben, Kommunikation und Dokumente. Vorhandene Fach- oder Buchhaltungssysteme können über
                            individuelle Schnittstellen ergänzt werden.</p>
                    </article>
                </section>

                <section class="section cta-section" aria-label="Demo der Immobilienverwaltungssoftware anfordern" i18n-aria-label>
                    <article class="card mb-0 cta-card">
                        <div>
                            <span class="eyebrow" i18n>ImmoConnect kennenlernen</span>
                            <h2 i18n>Mehr Überblick über Objekte, Schäden und Kommunikation</h2>
                            <p i18n>In einer persönlichen Demo zeigen wir Ihnen, wie ImmoConnect Ihre bestehenden Abläufe abbildet und welche Anpassungen für Ihre Immobilienverwaltung sinnvoll sind.</p>
                        </div>
                        <div class="cta-actions">
                            <a class="glow-on-hover p-3" [routerLink]="['/contact']" i18n>Demo anfragen</a>
                            <a class="text-link" [routerLink]="['/albcode/crm']" i18n>Auch das AlbCode CRM ansehen</a>
                        </div>
                    </article>
                </section>

                <section class="section" id="faq" aria-label="Häufige Fragen zu ImmoConnect" i18n-aria-label>
                    <h2 i18n>FAQ zur Immobilienverwaltungssoftware</h2>
                    <div class="grid grid-2 mt-3">
                        <article class="card mb-0">
                            <h3 i18n>Was ist ImmoConnect?</h3>
                            <p i18n>ImmoConnect ist eine webbasierte Arbeits- und Vorgangsplattform für Immobilienverwaltungen. Sie verbindet Objekte, Wohneinheiten, Kontakte, Schäden, Aufgaben,
                                E-Mails und Dokumente in digitalen Akten.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Ist ImmoConnect eine klassische Hausverwaltungs-Buchhaltung?</h3>
                            <p i18n>Der Schwerpunkt liegt auf operativen Verwaltungsprozessen, Kommunikation, Schadensmanagement und Dokumentation. Bestehende Buchhaltungs- oder Abrechnungslösungen
                                können bei Bedarf über Schnittstellen angebunden werden.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Kann ich E-Mails einem Objekt oder Schaden zuordnen?</h3>
                            <p i18n>Ja. Nachrichten und Anhänge lassen sich Wohneinheiten, Schäden, Projekten und Dienstleistungen zuordnen. Aufgaben können direkt aus E-Mails erstellt werden.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Gibt es einen Kalender und eine Android-App?</h3>
                            <p i18n>Ja. Der integrierte Kalender organisiert Termine, Teilnehmer, Einladungen und Erinnerungen. Die native Android-App macht den Kalender auch mobil verfügbar.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Lässt sich ImmoConnect an unsere Prozesse anpassen?</h3>
                            <p i18n>Ja. AlbCode entwickelt individuelle Erweiterungen, Rollen, Kategorien, Schnittstellen und Automatisierungen passend zu den Abläufen Ihrer Verwaltung.</p>
                        </article>
                        <article class="card mb-0">
                            <h3 i18n>Können Word- und Excel-Dateien im System bearbeitet werden?</h3>
                            <p i18n>Ja. Dokumente und Tabellen können direkt aus ImmoConnect geöffnet, bearbeitet und wieder am zugehörigen Objekt oder Vorgang gespeichert werden.</p>
                        </article>
                    </div>
                </section>
            </main>
        </div>
    </section>
</div>
